import SlidingBetslipControllerImpl from './sliding-betslip-controller.jsx';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import SlidingBetslipTypes from './types/index.js';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * SlidingBetslip module.
 *
 * @class SlidingBetslipController
 *
 * @extends Mojito.Core.Presentation.UIControllerView
 * @memberof Mojito.Modules.SlidingBetslip
 */

/**
 * SlidingBetslipController prop types.
 *
 * @memberof Mojito.Modules.SlidingBetslip.SlidingBetslipController
 *
 * @property {boolean} [isOpen = false] - True if sliding betslip should be opened, false otherwise.
 * @property {Mojito.Modules.SlidingBetslip.types.BETSLIP_TYPE} [betslipType = BETSLIP_TYPE.STANDARD_BETSLIP] - Betslip type.
 * @property {boolean} [isBetslipButtonMinimized = false] - True if betslip button should be minimized, false otherwise.
 */
const propTypes = {
    isOpen: PropTypes.bool,
    betslipType: PropTypes.string,
    isBetslipButtonMinimized: PropTypes.bool,
};

const defaultProps = {
    betslipType: SlidingBetslipTypes.BETSLIP_TYPE.STANDARD_BETSLIP,
    isOpen: false,
    isBetslipButtonMinimized: false,
};

export default UIControllerView(
    'SlidingBetslipController',
    SlidingBetslipControllerImpl,
    propTypes,
    defaultProps
);
